<template>
  <section class="trust-partners" aria-labelledby="trust-partners-title">
    <div class="trust-partners__inner">
      <div class="trust-partners__audiences">
        <h2 id="trust-partners-title">Used By</h2>

        <div class="trust-partners__ledger">
          <div>
            <img src="@/assets/images/researchers.png" alt="Researchers" loading="lazy" decoding="async">
            <p>Researchers</p>
          </div>
          <div>
            <img src="@/assets/images/utilities.png" alt="Utilities" loading="lazy" decoding="async">
            <p>Utilities</p>
          </div>
          <div>
            <img src="@/assets/images/government.png" alt="Government Agencies" loading="lazy" decoding="async">
            <p>Government Agencies</p>
          </div>
          <div>
            <img src="@/assets/images/aquariums.png" alt="Aquariums" loading="lazy" decoding="async">
            <p>Aquariums</p>
          </div>
          <div>
            <img src="@/assets/images/marinas.png" alt="Marinas" loading="lazy" decoding="async">
            <p>Marinas</p>
          </div>
          <div>
            <img src="@/assets/images/waterfront.png" alt="Waterfront" loading="lazy" decoding="async">
            <p>Waterfront Property Owners</p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default { name: 'TrustSequence' }
</script>

<style lang="scss">
#app .trust-partners {
  padding: clamp(70px, 6vw, 92px) 0 clamp(78px, 6vw, 98px);
  color: var(--ink);
  background: var(--sand);
}

#app .trust-partners__inner {
  width: min(1220px, calc(100% - 80px));
  margin: 0 auto;
  box-sizing: border-box;
}

#app .trust-partners__audiences h2 {
  margin-bottom: 38px;
  color: var(--ink);
  font-size: clamp(3.1rem, 5vw, 5.2rem);
}

#app .trust-partners__ledger {
  display: grid;
  width: 100%;
  border: 1px solid var(--line-light);
  box-sizing: border-box;
  grid-template-columns: repeat(6, minmax(0, 1fr));
}

#app .trust-partners__ledger > div {
  display: flex;
  min-width: 0;
  min-height: 146px;
  padding: 24px 14px;
  border-right: 1px solid var(--line-light);
  box-sizing: border-box;
  flex-direction: column;
  gap: 14px;
  align-items: center;
  justify-content: center;
  text-align: center;
}

#app .trust-partners__ledger > div:nth-child(n) { grid-column: auto; }
#app .trust-partners__ledger > div:last-child { border-right: 0; }

#app .trust-partners__ledger img {
  display: block;
  width: 34px;
  height: 34px;
  margin: 0;
  object-fit: contain;
  opacity: 0.62;
  filter: grayscale(1) brightness(0.62) contrast(1.45);
}

#app .trust-partners__ledger p {
  display: flex;
  min-height: 2.7em;
  max-width: 17ch;
  margin: 0;
  align-items: center;
  justify-content: center;
  color: var(--copy-dark);
  font-size: 1rem;
  line-height: 1.35;
  text-align: center;
  text-wrap: balance;
}

@media (max-width: 1024px) {
  #app .trust-partners__ledger { grid-template-columns: repeat(3, minmax(0, 1fr)); }
  #app .trust-partners__ledger > div,
  #app .trust-partners__ledger > div:nth-child(n) {
    border-right: 1px solid var(--line-light);
    border-bottom: 0;
    grid-column: auto;
  }
  #app .trust-partners__ledger > div:nth-child(3n) { border-right: 0; }
  #app .trust-partners__ledger > div:nth-child(-n + 3) { border-bottom: 1px solid var(--line-light); }
}

@media (max-width: 620px) {
  #app .trust-partners { padding: 66px 0 94px; }
  #app .trust-partners__inner { width: calc(100% - 40px); }
  #app .trust-partners__audiences h2 { margin-bottom: 42px; }
  #app .trust-partners__ledger { grid-template-columns: 1fr 1fr; }
  #app .trust-partners__ledger > div,
  #app .trust-partners__ledger > div:nth-child(n),
  #app .trust-partners__ledger > div:nth-child(3n) {
    display: flex;
    min-height: 134px;
    border-right: 1px solid var(--line-light);
    border-bottom: 1px solid var(--line-light);
  }
  #app .trust-partners__ledger > div:nth-child(even) { border-right: 0; }
  #app .trust-partners__ledger > div:nth-last-child(-n + 2) { border-bottom: 0; }
}
</style>
